export function data() {
  return {
    settingFilters: false,
    dependents: {
      fornecedor_cnpj: ["produto_desc", "sub_produto_desc", "cliente_cnpj", "transportadora"]
    },
    gates: [],
    selectRegiao: [],
    params: {
      data_inicio: {
        value: '',
        visible: false,
      },
      data_fim: {
        value: '',
        visible: false,
      },
      gate: {
        value: '',
        visible: false,
      },
      proprietario: {
        value: '',
        visible: false,
      },
      fornecedor_cnpj: {
        value: '',
        visible: false,
        get: this.getFornecedores,
      },
      produto_desc: {
        value: '',
        visible: false,
      },
      sub_produto_desc: {
        value: '',
        visible: false,
      },
      cliente_cnpj: {
        value: '',
        visible: false,
        get: this.getClientes,
      },
      transportadora: {
        value: '',
        visible: false,
        get: this.getTransportadoras,
      },
      terminal_cnpj: {
        value: '',
        visible: false,
        get: this.getContratos,
      },
      regiao_desc: {
        value: '',
        visible: false,
        get: this.getRegioes,
      },
      regiao: {
        value: [],
        visible: false,
        get: this.getRegioes,
      },
      representante_cpf: {
        value: '',
        visible: false,
        get: this.getRepresentantes,
      },
    },
  }
}
